











































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import Utils from '../../../utils/utils';
import { AppStore } from '@/store/modules/app';
import AMSTooltip from '../../../components/AMSTooltip.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
@Component({
  components: {
    'ams-tooltip': AMSTooltip,
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class RolePermission extends Vue {
  headers: any = [
    { text: '角色名', align: 'left', value: 'id', sortable: false, width: '30% ' },
    { text: '描述', align: 'left', sortable: false, width: '40% ' },
    { text: '操作', align: 'center', sortable: false, width: '30% ' }
  ];
  api: string = '/api/Setting/Role/list'; //tableapi
  routerhref: string = 'rolePermission_create';
  requestLoading: boolean = false;
  //table:
  loading: boolean = false;
  desserts: any = [];
  sortStr: string = '';
  deleteDialog: boolean = false;
  deleteName: string = '';
  deleteroleId: number | undefined = undefined;
  items = [
    {
      text: '系统设置',
      disabled: false,
      href: 'rolePermission'
    },
    {
      text: '角色权限',
      disabled: true
    }
  ];
  created() {
    this.getTableData();
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  deleteSure() {
    this.requestLoading = true;
    const self = this;
    request
      .del(`/api/Setting/Role/${this.deleteroleId}`, null)
      .then((data: any) => {
        this.deleteDialog = false;
        AppStore.ShowSuccess('删除成功！');
        self.getTableData();
      })
      .finally(() => {
        this.requestLoading = false;
      })
      .catch((err: any) => {
        this.requestLoading = false;
      });
  }
  deleterole() {
    this.deleteDialog = false;
  }
  addRole() {
    this.$router.push({
      name: 'rolePermission_create',
      params: {}
    });
  }
  deleteItem(item: any) {
    const self = this;
    self.deleteDialog = true;
    self.deleteName = item.displayName;
    self.deleteroleId = item.id;
  }
  goToEdit(record: any) {
    this.$router.push({
      name: this.routerhref,
      query: {
        type: 'edit',
        id: record.id
      }
    });
  }
  getTableData() {
    const self = this;
    request.get(self.api, null).then((data: any) => {
      self.desserts = data.items;
    });
  }
}
